export default {
  secret: 'JNHDB-VHC67-P463X-DYB3G-FVWDY',
  expiresIn: '7d',
};
